export default __webpack_public_path__ + "static/media/sadFaceV2.6b932baf.svg";